import { getAvailablePaymentMethods } from "app/pages/Booking/Payment/paymentSelector";
import { connect } from "react-redux";
import PaymentDescription from "app/pages/.shared/DynamicBlocks/blocks/PaymentDescriptionBlock/PaymentDescription";
import { getPaymentDescriptionBlock } from "app/reducers/partnerSelector";

const mapStateToProps = state => {
	const paymentDescriptionBlock = getPaymentDescriptionBlock(state);
	return {
		availablePaymentMethods: getAvailablePaymentMethods(state),
		message: paymentDescriptionBlock?.description,
	};
};

export default connect(mapStateToProps)(PaymentDescription);
